import classNames from "classnames";
import PropTypes from "prop-types";
import style from "./account.module.scss";
import AccountProfile from "./AccountProfile";
import useAccessKeyModal from "../../hooks/useAccessKeyModal";
import { Button } from "../Button/Button";
import AccessKeyModal from "../AccessKeyModal/AccessKeyModal";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { isPWAInstalled } from "../../utils";

const UnauthenticatedUser = ({ headername, onBackPress }) => {
  const { showAccessKey, openAccessKeyModal, closeAccessKeyModal } = useAccessKeyModal();
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      if (isPWAInstalled()) {
        await instance.loginRedirect(loginRequest);
      } else {
        const response = await instance.loginPopup(loginRequest);
        console.log("Login response:", response);
        window.location.reload();
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className="userNotLoggedIn">
      <AccountProfile />
      <div className={style.cardRow}>
        <Button bgColor="black" onClick={handleLogin}>
          Log in
        </Button>
        <Button onClick={openAccessKeyModal}>Access Key</Button>
      </div>
      <div className={style.cardRow}>
        <p>
          <a
            target="_blank"
            className={classNames(style.underline, style.link)}
            rel="noreferrer"
            href="https://app.tg.org.au/"
          >
            app.tg.org.au
          </a>
        </p>
      </div>
      <AccessKeyModal isOpen={showAccessKey} onClose={closeAccessKeyModal} />
    </div>
  );
};

UnauthenticatedUser.propTypes = {
  headername: PropTypes.string,
  onBackPress: PropTypes.func,
};

export default UnauthenticatedUser;
